import _extends from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import React from "react";
var __jsx = React.createElement;
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { FileButton, UnstyledButton } from "@mantine/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCloudArrowUp, faSpinner } from "@fortawesome/pro-regular-svg-icons";
/** Dashed upload area that opens the native file picker. */
export function FileDropZone(_ref) {
  var accept = _ref.accept,
    maxMb = _ref.maxMb,
    isUploading = _ref.isUploading,
    onFile = _ref.onFile,
    testId = _ref.testId;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var resetRef = useRef(null);
  var typesHint = accept.split(",").filter(Boolean).join(", ");
  return /*#__PURE__*/React.createElement(FileButton, {
    resetRef: resetRef,
    accept: accept,
    onChange: function onChange(file) {
      var _resetRef$current;
      if (file) onFile(file);
      (_resetRef$current = resetRef.current) === null || _resetRef$current === void 0 || _resetRef$current.call(resetRef);
    }
  }, function (props) {
    return /*#__PURE__*/React.createElement(UnstyledButton, _extends({}, props, {
      type: "button",
      "data-testid": testId,
      disabled: isUploading,
      className: "flex w-full flex-col items-center justify-center gap-2 rounded-sds-200 border border-dashed border-sds-base-default px-4 py-8 text-center hover:border-sds-brand-default"
    }), /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: isUploading ? faSpinner : faCloudArrowUp,
      spin: isUploading,
      className: "h-7 w-7 text-sds-brand-default"
    }), /*#__PURE__*/React.createElement("span", {
      className: "text-style-body-small-strong text-sds-base-default"
    }, isUploading ? t("uploading", {
      defaultValue: "Uploading…"
    }) : t("click_to_upload_a_file", {
      defaultValue: "Click to upload a file"
    })), typesHint ? /*#__PURE__*/React.createElement("span", {
      className: "text-style-label-base text-sds-base-tertiary"
    }, t("accepted_file_types_hint", {
      defaultValue: "Accepted: {{types}} · max {{mb}} MB",
      types: typesHint,
      mb: maxMb
    })) : null);
  });
}